const ContactUsIcon6 = (props) => {
	return ( 
		<div>
            <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M25.1562 33.9062H9.84375C5.03125 33.9062 1.09375 29.9688 1.09375 25.1562V9.84375C1.09375 5.03125 5.03125 1.09375 9.84375 1.09375H25.1562C29.9688 1.09375 33.9062 5.03125 33.9062 9.84375V25.1562C33.9062 29.9688 29.9688 33.9062 25.1562 33.9062Z" stroke="black" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M28.4375 17.5H22.9688V14.4375C22.9688 13.6719 23.5156 13.125 24.2813 13.125H27.3438V7.65625H22.9688C19.9063 7.65625 17.5 10.0625 17.5 13.125V17.5H13.125V22.9688H17.5V33.9062H22.9688V22.9688H26.25L28.4375 17.5Z" stroke="black" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
		</div>
	);
}

export default ContactUsIcon6;